import { ConfirmEmailPage } from "@/features/auth/pages/ConfirmEmail";

const ConfirmEmail = () => {
  return <ConfirmEmailPage />;
};

export default ConfirmEmail;
